import { render, staticRenderFns } from "./editBom.vue?vue&type=template&id=3204e7fc&scoped=true&"
import script from "./editBom.vue?vue&type=script&lang=js&"
export * from "./editBom.vue?vue&type=script&lang=js&"
import style0 from "./editBom.vue?vue&type=style&index=0&id=3204e7fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204e7fc",
  null
  
)

export default component.exports